import MatchedMap from 'utilities/src/matchedMap';

import { ThemeEnum, useTheme } from '../../../../../Theme';

import type { InputThemeProps } from '../../../utils/themes';

/**
 * Import Themes
 */

import inputMessageErrorBlogTheme from './_blog';
import inputMessageErrorSiteTheme from './_site';

/**
 * Group Themes
 */

const inputMessageErrorThemes = (fieldThemeProps: Pick<InputThemeProps, 'inputTheme'>) =>
  new MatchedMap([
    [ThemeEnum.Blog, inputMessageErrorBlogTheme(fieldThemeProps)],
    [ThemeEnum.Site, inputMessageErrorSiteTheme(fieldThemeProps)],
  ]);

/**
 * Theme Hook
 */

const useInputMessageErrorTheme = (fieldThemeProps: Pick<InputThemeProps, 'inputTheme'>) =>
  useTheme({}, inputMessageErrorThemes(fieldThemeProps));

export default useInputMessageErrorTheme;
